'use client';

import { c as _c } from "react/compiler-runtime";
import BrandMark from './BrandMark';

// The right half of the split-canvas onboarding: quiet brand atmosphere so the
// flow on the left never sits against an empty void. The mark itself is shared
// with the step-0 splash (see BrandMark), which glides it in from the center.
const BrandPanel = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div aria-hidden={true} className="pointer-events-none absolute inset-0" style={{
      background: "radial-gradient(120% 90% at 50% 0%, rgba(99,102,241,0.4), transparent 55%)"
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="relative flex h-full flex-col items-center justify-center overflow-hidden bg-background-secondary p-16">{t0}<div aria-hidden={true} className="pointer-events-none absolute inset-0 opacity-50" style={{
        backgroundImage: "linear-gradient(rgba(140,140,170,0.16) 1px, transparent 1px), linear-gradient(90deg, rgba(140,140,170,0.16) 1px, transparent 1px)",
        backgroundSize: "46px 46px",
        WebkitMaskImage: "radial-gradient(80% 70% at 50% 45%, #000, transparent 78%)",
        maskImage: "radial-gradient(80% 70% at 50% 45%, #000, transparent 78%)"
      }} /><BrandMark /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default BrandPanel;